import axiosInstance from "@js-app/services/http/axios-instance";

class SystemAvailabilityApi {
    getSystemAvailability(data) {
        return axiosInstance.post(`/system/availability`,
        {
            gate_apis: data.gate_apis,
            from: data.from,
            to: data.to
        },
        {
            withCredentials: true,
        })
    }
}

export default new SystemAvailabilityApi();